import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { ProfileService, UserRole } from '@core/profile.service';
import { PermissionDirective } from '@shared/directives/permission.directive';

interface Navigation {
  label: string;
  route: string;
  roles: UserRole[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    MatIcon,
    PermissionDirective,
  ],
  selector: 'norupe-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  profileSrv = inject(ProfileService);
  navigation: Navigation[] = [
    {
      label: 'Uzdevumu karte',
      roles: ['admin', 'manager', 'employee'],
      route: '/job',
    },
    {
      label: 'Siltumnicas karte',
      roles: ['admin', 'manager'],
      route: '/greenhouse',
    },
    {
      label: 'Sējumi',
      roles: ['admin', 'manager'],
      route: '/seeding',
    },
    {
      label: 'Pārskats',
      roles: ['admin', 'manager'],
      route: '/overview',
    },
  ];
  dialogOpen = false;

  toggleDialog() {
    this.dialogOpen = !this.dialogOpen;
  }
}
